import React from "react";
interface Props {
  big?: boolean;
  pathFill?: string;
}
export default function Icon(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.big ? "74" : "48"}
      height={props.big ? "74" : "48"}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M41.625 37.125H9.375V7.875C9.375 7.66875 9.20625 7.5 9 7.5H6.375C6.16875 7.5 6 7.66875 6 7.875V40.125C6 40.3312 6.16875 40.5 6.375 40.5H41.625C41.8312 40.5 42 40.3312 42 40.125V37.5C42 37.2938 41.8312 37.125 41.625 37.125ZM12.75 34.125H37.875C38.0812 34.125 38.25 33.9562 38.25 33.75V13.3125C38.25 12.975 37.8422 12.8109 37.6078 13.0453L27.75 22.9031L21.8719 17.0906C21.8014 17.0208 21.7062 16.9817 21.607 16.9817C21.5078 16.9817 21.4127 17.0208 21.3422 17.0906L12.4828 25.9781C12.4484 26.0126 12.4212 26.0535 12.4027 26.0986C12.3842 26.1436 12.3748 26.1919 12.375 26.2406V33.75C12.375 33.9562 12.5437 34.125 12.75 34.125Z"
        fill="#262C34"
      />
    </svg>
  );
}
